import React from 'react';
import PrivacyPolicyData from '../components/privacy-policy-data';
import usePageMeta from '../hooks/usePageMeta';

export default function PrivacyPolicy() {
    usePageMeta(
        'Privacy Policy | Spinnennetz',
        'Learn how Spinnennetz collects, uses, and protects your personal information. Our privacy policy covers data collection, usage, third-party sharing, cookies, and your rights.',
        '/privacy-policy',
        {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Privacy Policy | Spinnennetz",
            "description": "Learn how Spinnennetz collects, uses, and protects your personal information."
        }
    );

    return (
        <>
            <PrivacyPolicyData />
        </>
    );
}
